import { useId } from "react";
import { FormattedMessage } from "react-intl";
import type { EscoLanguage } from "@/lib/esco";

export function EscoLanguageSelect({ value, onChange }: {
  value: EscoLanguage; onChange: (value: EscoLanguage) => void;
}) {
  const id = useId();
  return <label htmlFor={`${id}-language`} className="block shrink-0 space-y-1">
    <span className="smycles-field-meta"><FormattedMessage id="esco.searchLanguage" defaultMessage="Search language" /></span>
    <select id={`${id}-language`} value={value} onChange={e => onChange(e.target.value === "de" ? "de" : "en")}
      className="smycles-field-value rounded-md bg-surface px-3 py-2 ring-1 ring-ink-ui">
      <option value="de">Deutsch</option>{/* i18n-allow: language autonym */}
      <option value="en">English</option>{/* i18n-allow: language autonym */}
    </select>
  </label>;
}
